<script setup lang="ts">
  import { Motion } from 'motion-v'
  import DashboardSidebar from '@/components/core/sidebar/DashboardSidebar.vue'
  import DashboardNavbar from '@/components/core/DashboardNavbar.vue'
  import { useAppStore } from '@/stores/app'
  import { buildFadeTransition, routePagePreset } from '@/utils/motion'

  const store = useAppStore()
</script>

<template>
  <div class="h-screen overflow-hidden bg-bg-secondary">
    <!-- Sidebar -->
    <DashboardSidebar />

    <!-- Main Content Area -->
    <div
      class="transition-all duration-300 h-screen min-h-0 flex flex-col"
      :style="{
        marginInlineStart: store.wrapperLeftOffset + 'px',
        width: `calc(100% - ${store.wrapperLeftOffset}px)`
      }"
    >
      <!-- Navbar -->
      <DashboardNavbar />

      <!-- Page Content -->
      <main class="flex-1 min-h-0">
        <div class="max-w-[1440px] h-full min-h-0 mx-auto">
          <RouterView v-slot="{ Component, route }">
            <Motion
              :key="route.fullPath"
              :initial="routePagePreset.initial"
              :animate="routePagePreset.animate"
              :transition="buildFadeTransition()"
              class="h-full"
            >
              <component :is="Component" />
            </Motion>
          </RouterView>
        </div>
      </main>
    </div>
  </div>
</template>
